import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "src/components/Layout";

const LayoutNoSidebar = () => <Layout withSidebar={false} />;

export const Route = createFileRoute("/_layout-nosidebar")({
    component: LayoutNoSidebar,
});
